// Frans (fr-FR), virtualDevice: zelfde vorm als virtualDevice.nl.ts (golf 3-integratie).
export const appVirtualDeviceFr = {
    title: 'iPad virtuel',
    intro: 'Le vrai tableau familial, exactement comme sur la tablette au mur.',
    entry: 'iPad virtuel',
    entryBody: 'Le tableau dans ton navigateur, pour regarder et essayer.',
    orientation: 'Orientation',
    landscape: 'Paysage',
    portrait: 'Portrait',
    zoom: 'Taille',
    fit: 'Ajuster',
    actual: '100 %',
    profile: 'Tablette de',
    roomEveryone: '{room}, tout le monde',
    roomMembers: '{room}, {names}',
    ownWindow: 'Fenêtre séparée',
    ownWindowLabel: 'Ouvre l’iPad virtuel dans une fenêtre séparée de 1024 sur 768',
    pairTitle: 'Associer cet iPad virtuel',
    pairBody: 'Il devient une tablette à part entière dans ta famille. Tu le retrouves ensuite dans Tablettes et tu peux l’y dissocier.',
    pairButton: 'Associer',
    pairWaiting: 'Le tableau crée un code d’association…',
    pairedToast: 'iPad virtuel associé',
    status: '{name} dans {room}',
    moved: 'Le tableau affiche maintenant la tablette de {room}',
    revoke: 'Dissocier',
    revokeTitle: 'Dissocier l’iPad virtuel ?',
    revokeBody: 'Le tableau dans ton navigateur affiche ensuite de nouveau un code d’association. Tes vraies tablettes ne remarquent rien.',
    revoked: 'iPad virtuel dissocié',
    hint: 'Chaque clic est une touche. Le son et la lecture à voix haute marchent après ton premier clic sur le tableau, comme sur l’iPad.',
    storageTitle: 'Ce navigateur ne garde pas l’association dans la page',
    storageBody: 'Certains navigateurs (souvent Safari) conservent un tableau intégré à part. Ouvre l’iPad dans une fenêtre séparée : il y reste associé.',
    popupBlocked: 'Ton navigateur a bloqué la fenêtre. Autorise les fenêtres pop-up pour ce site et réessaie.',
    frameTitle: 'Tableau familial sur l’iPad virtuel',
    foreignTitle: 'Ce tableau est associé comme {name}, une tablette normale',
    foreignBody: 'Tu as déjà ouvert le tableau directement dans ce navigateur. Associe-le de nouveau comme iPad virtuel : {name} sera alors dissocié.',
    foreignButton: 'Associer de nouveau comme iPad virtuel',
    foreignOtherTitle: 'Ce tableau appartient à une autre famille',
    foreignOtherBody: 'Ce navigateur est associé comme tablette d’une autre famille. Dissocie-le là-bas dans Tablettes, ou ouvre cette page dans une fenêtre privée.',
    foreignStatus: '{name} dans {room} (tablette normale)',
    stuckTitle: 'Le tableau ne répond pas',
    stuckBody: 'Recharge le tableau. S’il reste vide, ouvre-le dans une fenêtre séparée.',
    stuckReload: 'Recharger',
    tag: 'Virtuel',
    openOnDevice: 'Ouvrir',
};
//# sourceMappingURL=virtualDevice.fr.js.map